var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _g, _g2, _g3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 788,
    height: 721,
    viewBox: "0 0 788 721",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M99.4045 167.358C227.163 21.9864 446.507 -2.22691 544.309 44.486C585.169 64.0137 619.739 87.917 648.621 114.191C652.704 117.892 656.678 121.648 660.526 125.441C672.924 137.657 684.156 150.274 694.312 163.128C707.33 179.593 718.562 196.44 728.116 213.269C743.504 240.326 754.591 267.311 761.902 292.529C767.681 312.438 771.109 331.255 772.44 348.157C775.23 383.547 772.805 419.194 768.047 454.364C767.609 457.72 767.134 461.075 766.624 464.429C766.496 465.359 766.369 466.288 766.222 467.219C760.99 502.172 753.587 537.434 737.069 567.92C719.053 601.159 656.058 693.656 587.776 696.081C552.349 697.337 521.061 674.144 488.953 657.772C437.865 631.736 380.12 626.629 323.781 625.117C267.439 623.604 210.408 625.226 155.507 611.259C100.608 597.311 46.7658 565.203 18.7051 511.799C9.16926 493.675 1.93075 467.566 1.9125 446.67C1.89427 385.024 11.9771 331.109 29.5537 284.269C35.2789 268.971 41.8064 254.44 49.0448 240.636C60.1853 219.36 73.0213 199.832 87.1884 181.981L99.4045 167.358Z",
    fill: "#DFFF02",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M136.148 191.351C247.73 64.1573 439.303 42.9718 524.722 83.8433C560.408 100.929 590.601 121.843 615.826 144.832C619.392 148.07 622.863 151.356 626.224 154.675C637.052 165.363 646.862 176.403 655.732 187.65C667.102 202.055 676.911 216.796 685.256 231.521C698.696 255.194 708.378 278.805 714.764 300.869C719.812 318.288 722.805 334.752 723.968 349.541C726.405 380.505 724.287 411.694 720.131 442.467C719.748 445.403 719.334 448.338 718.888 451.273C718.776 452.087 718.666 452.9 718.537 453.715C713.967 484.296 707.502 515.149 693.075 541.823C677.341 570.905 622.322 651.835 562.685 653.957C531.744 655.057 504.417 634.764 476.374 620.439C431.755 597.658 381.321 593.191 332.115 591.867C282.907 590.544 233.097 591.962 185.148 579.742C137.199 567.539 90.1742 539.445 65.6665 492.72C57.338 476.862 51.016 454.018 51 435.735C50.9841 381.797 59.7903 334.625 75.1415 293.642C80.1418 280.257 85.8428 267.543 92.1647 255.465C101.895 236.85 113.105 219.763 125.479 204.145L136.148 191.351Z",
    fill: "#DFFF02",
    fillOpacity: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M186.967 225.038C276.034 123.326 428.951 106.385 497.134 139.068C525.619 152.731 549.72 169.455 569.855 187.838C572.702 190.428 575.472 193.056 578.155 195.709C586.799 204.257 594.629 213.084 601.709 222.078C610.784 233.598 618.615 245.385 625.276 257.16C636.003 276.091 643.732 294.971 648.83 312.615C652.859 326.545 655.248 339.71 656.176 351.536C658.121 376.297 656.431 401.238 653.113 425.845C652.808 428.194 652.477 430.541 652.121 432.888C652.032 433.538 651.944 434.188 651.841 434.84C648.194 459.295 643.032 483.966 631.517 505.297C618.957 528.553 575.04 593.269 527.437 594.966C502.739 595.845 480.926 579.618 458.542 568.163C422.926 549.946 382.669 546.373 343.392 545.315C304.113 544.256 264.353 545.391 226.079 535.619C187.806 525.86 150.27 503.395 130.707 466.031C124.059 453.35 119.013 435.082 119 420.462C118.987 377.33 126.017 339.608 138.27 306.836C142.262 296.133 146.812 285.966 151.859 276.307C159.625 261.421 168.574 247.758 178.45 235.269L186.967 225.038Z",
    fill: "#DFFF02",
    fillOpacity: 0.45
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.91248 693.927H786.024",
    stroke: "#727272",
    strokeWidth: 1.91247,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M605.351 429.42C605.332 429.439 605.332 429.456 605.351 429.475C605.368 429.548 605.388 429.601 605.407 429.676C605.479 430.003 605.533 430.349 605.625 430.714C606.244 433.65 606.956 437.697 607.466 442.803C607.813 446.286 608.086 450.26 608.159 454.691C608.323 463.242 607.849 473.489 606.063 485.212C605.661 487.893 605.187 490.647 604.623 493.491C603.728 498.121 602.616 502.971 601.285 507.986C600.666 510.319 599.991 512.708 599.262 515.115C598.969 516.1 598.679 517.066 598.405 518.051C598.076 519.237 597.747 520.44 597.42 521.623C597.42 521.643 597.401 521.66 597.401 521.679C595.286 529.755 593.645 538.034 592.387 546.258C590.838 556.558 589.872 566.788 589.342 576.469C588.631 589.359 588.669 601.283 588.979 611.148C588.979 611.312 588.979 611.458 588.996 611.622C589.325 621.615 589.944 629.418 590.363 633.885C590.6 636.475 590.765 637.951 590.782 638.06",
    stroke: "#4A4A4A",
    strokeWidth: 1.91247,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M605.405 429.674C605.386 429.638 605.386 429.638 605.368 429.638C605.349 429.601 605.349 429.601 605.332 429.601C604.018 428.452 602.578 427.45 601.065 426.629C599.388 425.753 597.602 425.061 595.76 424.623",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M605.405 429.674C605.386 429.638 605.386 429.638 605.368 429.638C605.349 429.601 605.349 429.601 605.332 429.601C604.018 428.452 602.578 427.45 601.065 426.629C599.388 425.753 597.602 425.061 595.76 424.623",
    stroke: "#4A4A4A",
    strokeWidth: 1.91247,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M607.447 442.801L612.297 438.406",
    stroke: "#4A4A4A",
    strokeWidth: 1.91247,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M601.268 508.022C601.014 506.727 600.648 505.469 600.121 504.266C599.409 502.497 598.424 500.837 597.221 499.36C596.328 498.249 595.307 497.245 594.177 496.352",
    stroke: "#4A4A4A",
    strokeWidth: 1.91247,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M597.384 521.698C598.715 518.305 601.561 515.498 604.969 514.203",
    stroke: "#4A4A4A",
    strokeWidth: 1.91247,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M588.961 589.522C590.583 587.571 591.805 580.114 592.48 576.102C592.645 575.136 592.773 574.335 592.882 573.732",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M588.961 589.522C590.583 587.571 591.805 580.114 592.48 576.102C592.645 575.136 592.773 574.335 592.882 573.732",
    stroke: "#4A4A4A",
    strokeWidth: 1.91247,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M576.471 602.98C577.018 602.943 577.565 602.96 578.112 603.033C582.834 603.471 587.265 606.717 588.996 611.148",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M576.471 602.98C577.018 602.943 577.565 602.96 578.112 603.033C582.834 603.471 587.265 606.717 588.996 611.148",
    stroke: "#4A4A4A",
    strokeWidth: 1.91247,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M604.603 493.583C604.603 493.583 605.46 463.991 589.216 453.27",
    stroke: "#4A4A4A",
    strokeWidth: 1.91247,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M606.063 557.09C608.197 563.981 593.318 577.127 593.318 577.127C593.318 577.127 573.627 574.665 571.493 567.773C569.36 560.882 574.356 549.578 583.891 546.642C593.446 543.67 603.93 550.197 606.063 557.09Z",
    fill: "#97EC5F"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M622.565 473.341C620.687 480.672 606.592 485.868 606.592 485.868C606.592 485.868 596.783 474.508 598.661 467.179C600.539 459.849 608.325 451.773 614.925 453.467C621.544 455.183 624.46 466.013 622.565 473.341Z",
    fill: "#97EC5F"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M566.06 582.87C574.903 586.316 580.317 601.96 580.317 601.96C580.317 601.96 565.75 609.819 556.906 606.372C548.063 602.926 538.709 593.226 541.226 586.735C543.76 580.244 557.216 579.424 566.06 582.87Z",
    fill: "#97EC5F"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M585.439 496.807C587.317 498.194 589.231 499.617 591.474 500.217C593.718 500.819 596.397 500.454 597.91 498.704C599.807 496.534 599.296 493.143 598.111 490.517C595.741 485.304 587.043 476.478 580.334 479.012C570.688 482.678 581.136 493.617 585.439 496.807Z",
    fill: "#97EC5F"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M605.223 510.084C603.946 511.652 602.614 513.639 603.309 515.536C603.928 517.213 605.988 517.997 607.757 517.724C609.526 517.45 611.075 516.41 612.534 515.391C615.944 513.019 622.946 508.06 618.478 503.411C613.829 498.561 607.885 506.766 605.223 510.084Z",
    fill: "#97EC5F"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M576.689 443.933C575.232 444.098 573.753 445.063 573.499 446.523C573.206 448.219 574.61 449.695 575.978 450.734C579.37 453.342 589.545 460.398 591.822 453.597C593.957 447.179 581.176 443.442 576.689 443.933Z",
    fill: "#97EC5F"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M595.452 421.58C593.354 421.779 591.258 421.014 589.143 421.142C587.047 421.269 584.695 422.965 585.169 425.025C585.605 426.922 587.957 427.561 589.908 427.687C593.228 427.888 596.583 427.67 599.845 426.995C600.612 426.849 601.433 426.612 601.851 425.973C602.708 424.715 601.341 423.038 599.901 422.6C598.461 422.164 596.82 422.309 595.506 421.561L595.452 421.58Z",
    fill: "#97EC5F"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M615.981 436.037C618.096 436.092 620.138 435.199 622.234 435.199C624.35 435.199 626.792 436.729 626.465 438.808C626.155 440.741 623.839 441.525 621.905 441.78C618.606 442.201 615.25 442.201 611.951 441.743C611.184 441.634 610.346 441.47 609.872 440.869C608.943 439.665 610.182 437.915 611.605 437.368C613.026 436.821 614.667 436.876 615.925 436.037H615.981Z",
    fill: "#97EC5F"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M613.904 591.419C614.432 590.983 615.015 590.526 615.69 590.526C616.602 590.526 617.314 591.382 617.476 592.277C617.641 593.171 617.404 594.081 617.13 594.94C615.709 599.715 599.644 634.359 595.961 628.142C593.773 624.459 599.153 612.278 600.721 608.832C603.802 602.176 608.287 596.16 613.904 591.419Z",
    fill: "#97EC5F"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M606.08 431.701C606.08 431.701 605.112 423.296 607.138 422.621",
    stroke: "#4A4A4A",
    strokeWidth: 1.91247,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M604.295 422.894C605.571 420.031 606.938 417.042 609.472 415.2C612.006 413.358 616.055 413.211 617.897 415.747C619.957 418.572 617.897 422.875 614.741 424.39C611.588 425.902 607.887 425.447 604.422 424.954C604.385 424.443 604.368 423.932 604.332 423.405L604.295 422.894Z",
    fill: "#97EC5F"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M612.936 693.508C595.869 696.425 578.074 696.425 561.009 693.508L540.805 633.904H633.137L612.936 693.508Z",
    fill: "white",
    stroke: "#4A4A4A",
    strokeWidth: 1.91247,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M260.566 262.878C260.547 262.897 260.547 262.914 260.566 262.934C260.583 263.006 260.602 263.06 260.619 263.134C260.692 263.461 260.748 263.808 260.839 264.173C261.459 267.108 262.17 271.155 262.681 276.261C263.027 279.744 263.301 283.718 263.373 288.149C263.538 296.7 263.064 306.947 261.277 318.67C260.876 321.352 260.401 324.106 259.835 326.95C258.942 331.58 257.831 336.43 256.5 341.444C255.88 343.777 255.205 346.149 254.475 348.574C254.184 349.559 253.891 350.524 253.618 351.509C253.291 352.693 252.962 353.898 252.635 355.082C252.635 355.101 252.616 355.118 252.616 355.137C250.501 363.214 248.86 371.493 247.601 379.716C246.052 390.017 245.086 400.247 244.557 409.928C243.845 422.818 243.882 434.742 244.191 444.606C244.191 444.771 244.191 444.916 244.21 445.081C244.539 455.073 245.159 462.876 245.578 467.344C245.815 469.933 245.98 471.41 245.997 471.519",
    stroke: "#4A4A4A",
    strokeWidth: 1.91247,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M260.6 263.133C260.583 263.096 260.583 263.096 260.564 263.096C260.545 263.06 260.545 263.06 260.528 263.06C259.216 261.91 257.774 260.908 256.261 260.088C254.584 259.212 252.798 258.52 250.956 258.082",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M260.6 263.133C260.583 263.096 260.583 263.096 260.564 263.096C260.545 263.06 260.545 263.06 260.528 263.06C259.216 261.91 257.774 260.908 256.261 260.088C254.584 259.212 252.798 258.52 250.956 258.082",
    stroke: "#4A4A4A",
    strokeWidth: 1.91247,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M262.662 276.26L267.512 271.865",
    stroke: "#4A4A4A",
    strokeWidth: 1.91247,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M256.464 341.481C256.209 340.186 255.844 338.927 255.316 337.725C254.605 335.955 253.62 334.295 252.417 332.819C251.524 331.708 250.503 330.704 249.372 329.811",
    stroke: "#4A4A4A",
    strokeWidth: 1.91247,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M252.599 355.155C253.93 351.764 256.774 348.956 260.183 347.662",
    stroke: "#4A4A4A",
    strokeWidth: 1.91247,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M244.157 422.98C245.781 421.03 247.001 413.573 247.676 409.561C247.84 408.595 247.969 407.793 248.078 407.191",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M244.157 422.98C245.781 421.03 247.001 413.573 247.676 409.561C247.84 408.595 247.969 407.793 248.078 407.191",
    stroke: "#4A4A4A",
    strokeWidth: 1.91247,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M231.667 436.438C232.214 436.402 232.761 436.419 233.308 436.492C238.03 436.93 242.461 440.175 244.191 444.606",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M231.667 436.438C232.214 436.402 232.761 436.419 233.308 436.492C238.03 436.93 242.461 440.175 244.191 444.606",
    stroke: "#4A4A4A",
    strokeWidth: 1.91247,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M259.799 327.041C259.799 327.041 260.656 297.45 244.411 286.729",
    stroke: "#4A4A4A",
    strokeWidth: 1.91247,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M261.277 390.549C263.412 397.439 248.533 410.586 248.533 410.586C248.533 410.586 228.842 408.124 226.708 401.232C224.575 394.341 229.571 383.036 239.106 380.101C248.661 377.129 259.145 383.656 261.277 390.549Z",
    fill: "#97EC5F"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M277.776 306.8C275.898 314.13 261.803 319.327 261.803 319.327C261.803 319.327 251.994 307.966 253.872 300.638C255.75 293.307 263.536 285.231 270.136 286.926C276.736 288.641 279.654 299.471 277.776 306.8Z",
    fill: "#97EC5F"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M221.255 416.329C230.098 419.775 235.513 435.419 235.513 435.419C235.513 435.419 220.945 443.277 212.102 439.831C203.259 436.385 193.905 426.685 196.422 420.194C198.956 413.703 212.412 412.883 221.255 416.329Z",
    fill: "#97EC5F"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M240.653 330.266C242.531 331.652 244.446 333.075 246.689 333.676C248.93 334.278 251.612 333.913 253.124 332.163C255.022 329.992 254.511 326.602 253.325 323.976C250.956 318.762 242.258 309.936 235.547 312.47C225.902 316.137 236.331 327.076 240.653 330.266Z",
    fill: "#97EC5F"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M260.419 343.542C259.141 345.11 257.81 347.097 258.504 348.995C259.124 350.672 261.184 351.456 262.953 351.182C264.722 350.909 266.271 349.869 267.73 348.849C271.14 346.478 278.142 341.519 273.674 336.87C269.042 332.02 263.098 340.224 260.419 343.542Z",
    fill: "#97EC5F"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M231.885 277.392C230.427 277.556 228.949 278.522 228.695 279.981C228.402 281.678 229.806 283.154 231.173 284.193C234.566 286.801 244.74 293.856 247.018 287.056C249.152 280.637 236.389 276.9 231.885 277.392Z",
    fill: "#97EC5F"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M250.648 255.039C248.55 255.238 246.454 254.473 244.339 254.601C242.243 254.727 239.89 256.424 240.365 258.483C240.801 260.38 243.153 261.019 245.104 261.145C248.424 261.346 251.778 261.128 255.041 260.453C255.808 260.308 256.628 260.071 257.047 259.432C257.904 258.173 256.536 256.496 255.096 256.058C253.656 255.622 252.015 255.768 250.701 255.02L250.648 255.039Z",
    fill: "#97EC5F"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M271.176 269.495C273.292 269.551 275.334 268.658 277.43 268.658C279.545 268.658 281.988 270.188 281.661 272.267C281.351 274.2 279.035 274.984 277.101 275.239C273.802 275.659 270.448 275.659 267.147 275.202C266.38 275.093 265.542 274.929 265.068 274.328C264.139 273.123 265.378 271.373 266.801 270.826C268.222 270.28 269.863 270.335 271.121 269.495H271.176Z",
    fill: "#97EC5F"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M269.099 424.878C269.627 424.442 270.211 423.984 270.886 423.984C271.798 423.984 272.509 424.841 272.672 425.736C272.836 426.629 272.599 427.54 272.326 428.396C270.905 433.174 254.84 467.818 251.159 461.599C248.969 457.917 254.349 445.737 255.917 442.291C258.998 435.635 263.482 429.619 269.099 424.878Z",
    fill: "#97EC5F"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M261.276 265.16C261.276 265.16 260.308 256.755 262.333 256.079",
    stroke: "#4A4A4A",
    strokeWidth: 1.91247,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M259.508 256.353C260.786 253.49 262.153 250.499 264.687 248.659C267.221 246.817 271.27 246.67 273.112 249.206C275.171 252.031 273.112 256.334 269.956 257.848C266.802 259.361 263.102 258.906 259.636 258.413C259.6 257.902 259.581 257.391 259.545 256.864L259.508 256.353Z",
    fill: "#97EC5F"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M592.042 464.423H569.781",
    stroke: "#4A4A4A",
    strokeWidth: 1.91247,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M350.163 467.728H1.91248V693.927H350.163V467.728Z",
    fill: "white",
    stroke: "#4A4A4A",
    strokeWidth: 1.91247,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M1.91248 467.728L176.038 580.828L350.163 467.728H1.91248Z",
    fill: "white",
    stroke: "#4A4A4A",
    strokeWidth: 1.91247,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M123.691 546.824L1.91248 693.927",
    stroke: "#4A4A4A",
    strokeWidth: 1.91247,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M229.332 546.824L351.11 693.927",
    stroke: "#4A4A4A",
    strokeWidth: 1.91247,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M541.301 167.139H309.54C296.595 167.139 286.094 177.824 286.094 191.024V668.111C286.094 681.291 296.595 691.996 309.54 691.996H541.301C554.246 691.996 564.767 681.291 564.767 668.111V191.024C564.786 177.824 554.246 167.139 541.301 167.139ZM550.108 653.36C550.108 665.921 540.698 676.078 529.103 676.078H321.774C310.143 676.078 300.753 665.921 300.753 653.36V209.112C300.753 183.531 310.16 182.291 321.774 182.291H363.309C365.717 182.291 367.704 185.026 367.704 188.435V189.894C367.704 197.862 372.063 197.88 377.404 197.88H473.456C478.853 197.88 483.192 197.844 483.192 189.894V188.435C483.192 185.044 485.143 182.291 487.585 182.291H529.103C540.698 182.291 550.108 185.682 550.108 209.112V653.36Z",
    fill: "#4A4A4A"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M550.127 209.11V653.377C550.127 665.938 540.719 676.095 529.124 676.095H321.795C310.162 676.095 300.774 665.938 300.774 653.377V209.11C300.774 183.529 310.181 182.29 321.795 182.29H363.33C365.736 182.29 367.725 185.025 367.725 188.434V189.893C367.725 197.861 372.082 197.879 377.425 197.879H473.475C478.872 197.879 483.212 197.843 483.212 189.893V188.434C483.212 185.043 485.164 182.29 487.606 182.29H529.124C540.719 182.271 550.127 185.681 550.127 209.11Z",
    fill: "white"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M550.127 209.11V249.424H300.755V209.11C300.755 183.529 310.162 182.29 321.776 182.29H363.311C365.719 182.29 367.706 185.025 367.706 188.434V189.893C367.706 197.861 372.063 197.879 377.406 197.879H473.458C478.855 197.879 483.194 197.843 483.194 189.893V188.434C483.194 185.043 485.145 182.29 487.587 182.29H529.105C540.72 182.271 550.127 185.681 550.127 209.11Z",
    fill: "#DFFF02"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M438.54 187.541H412.339C411.446 187.541 410.718 186.812 410.718 185.918C410.718 185.025 411.446 184.295 412.339 184.295H438.54C439.435 184.295 440.164 185.025 440.164 185.918C440.145 186.812 439.435 187.541 438.54 187.541Z",
    fill: "white"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M356.147 191.862C356.019 191.99 355.874 192.136 355.746 192.263C355.673 192.336 355.6 192.409 355.526 192.5C354.451 191.461 353.156 190.896 351.661 190.896C350.167 190.896 348.872 191.443 347.796 192.5C347.723 192.428 347.65 192.354 347.577 192.282C347.449 192.154 347.321 192.008 347.176 191.881C347.176 191.881 347.176 191.881 347.157 191.881C347.157 191.881 347.157 191.881 347.157 191.862C347.176 191.862 347.176 191.844 347.195 191.844C347.358 191.698 347.522 191.534 347.704 191.388C348.069 191.096 348.451 190.841 348.872 190.641C349.364 190.404 349.893 190.221 350.421 190.112C350.676 190.057 350.932 190.039 351.205 190.003C351.297 189.984 351.861 189.984 351.881 189.984C352.062 190.002 352.227 190.002 352.408 190.021C352.902 190.075 353.374 190.185 353.831 190.367C354.158 190.495 354.487 190.641 354.797 190.823C355.126 191.005 355.436 191.224 355.727 191.461C355.855 191.589 356 191.716 356.147 191.862Z",
    fill: "white"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M349.054 193.76C348.836 193.541 348.635 193.34 348.417 193.122C349.146 192.41 349.985 191.955 351.005 191.827C352.5 191.626 353.795 192.082 354.889 193.122C354.671 193.34 354.47 193.541 354.25 193.76C353.54 193.067 352.665 192.684 351.662 192.684C350.641 192.684 349.765 193.049 349.054 193.76Z",
    fill: "white"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M353.613 194.377C353.412 194.577 353.194 194.796 352.974 195.015C352.611 194.668 352.173 194.468 351.643 194.468C351.135 194.468 350.678 194.668 350.314 195.015C350.094 194.796 349.893 194.595 349.675 194.377C350.697 193.337 352.502 193.246 353.613 194.377Z",
    fill: "white"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M352.206 195.581C352.206 195.891 351.951 196.146 351.641 196.146C351.332 196.146 351.075 195.891 351.075 195.581C351.075 195.271 351.332 195.016 351.641 195.016C351.951 195.016 352.206 195.271 352.206 195.581Z",
    fill: "white"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M316.999 193.085C316.999 192.173 317.747 191.426 318.657 191.426C319.569 191.426 320.317 192.173 320.317 193.085C320.317 193.997 319.569 194.744 318.657 194.744C317.747 194.726 316.999 193.997 316.999 193.085Z",
    fill: "white"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M322.212 193.085C322.212 192.173 322.96 191.426 323.872 191.426C324.785 191.426 325.532 192.173 325.532 193.085C325.532 193.997 324.785 194.744 323.872 194.744C322.96 194.726 322.212 193.997 322.212 193.085Z",
    fill: "white"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M327.409 193.085C327.409 192.173 328.156 191.426 329.069 191.426C329.981 191.426 330.727 192.173 330.727 193.085C330.727 193.997 329.981 194.744 329.069 194.744C328.156 194.726 327.409 193.997 327.409 193.085Z",
    fill: "white"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M332.624 193.085C332.624 192.173 333.372 191.426 334.282 191.426C335.194 191.426 335.942 192.173 335.942 193.085C335.942 193.997 335.194 194.744 334.282 194.744C333.372 194.726 332.624 193.997 332.624 193.085Z",
    fill: "white"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M337.82 193.085C337.82 192.173 338.568 191.426 339.478 191.426C340.39 191.426 341.138 192.173 341.138 193.085C341.138 193.997 340.39 194.744 339.478 194.744C338.568 194.726 337.82 193.997 337.82 193.085Z",
    fill: "white"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M531.402 196.676H517.946V190.44H531.402V196.676ZM518.638 196.001H530.727V191.133H518.638V196.001Z",
    fill: "white"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M527.757 191.516H519.078V195.636H527.757V191.516Z",
    fill: "white"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M532.622 191.9H531.419V195.237H532.622V191.9Z",
    fill: "white"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M324.383 233.998L316.999 227.086L324.383 220.196L325.513 221.399L319.441 227.086L325.513 232.776L324.383 233.998Z",
    fill: "white"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M519.131 225.939C519.441 226.122 519.606 226.449 519.587 226.796C519.587 226.887 519.587 226.979 519.587 227.088C519.587 227.18 519.587 227.289 519.587 227.381C519.606 227.727 519.441 228.054 519.131 228.238L518.091 228.838L520.042 232.212L521.082 231.609C521.392 231.428 521.757 231.447 522.048 231.646C522.212 231.757 522.377 231.846 522.559 231.938C522.868 232.103 523.069 232.413 523.069 232.759V233.944H526.971V232.759C526.971 232.413 527.171 232.103 527.481 231.938C527.646 231.846 527.827 231.757 527.992 231.646C528.285 231.447 528.667 231.447 528.958 231.609L529.998 232.212L531.949 228.838L530.91 228.238C530.601 228.054 530.436 227.727 530.453 227.381C530.453 227.289 530.453 227.197 530.453 227.088C530.453 226.996 530.453 226.887 530.453 226.796C530.436 226.449 530.601 226.103 530.91 225.939L531.949 225.338L529.998 221.965L528.958 222.567C528.648 222.749 528.285 222.73 527.992 222.531C527.827 222.42 527.665 222.33 527.481 222.238C527.171 222.074 526.971 221.764 526.971 221.418V220.232H523.069V221.418C523.069 221.764 522.868 222.074 522.559 222.238C522.377 222.33 522.212 222.42 522.048 222.531C521.757 222.73 521.373 222.73 521.082 222.567L520.042 221.965L518.091 225.338L519.131 225.939ZM525.02 223.898C526.789 223.898 528.212 225.338 528.212 227.088C528.212 228.857 526.77 230.278 525.02 230.278C523.251 230.278 521.83 228.857 521.83 227.088C521.83 225.319 523.251 223.898 525.02 223.898Z",
    stroke: "white",
    strokeWidth: 1.43435,
    strokeMiterlimit: 10
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M403.99 222.932C403.99 222.477 404.336 222.129 404.793 222.129C405.231 222.129 405.613 222.477 405.613 222.932V231.556C405.613 232.013 405.231 232.359 404.793 232.359C404.336 232.359 403.99 232.013 403.99 231.556V222.932Z",
    fill: "white"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M409.953 231.556C409.953 231.994 409.587 232.359 409.168 232.359C408.711 232.359 408.365 231.994 408.365 231.556V223.061C408.365 223.061 408.365 223.061 408.365 223.042C408.348 222.787 408.474 222.531 408.694 222.366C409.059 222.112 409.551 222.185 409.805 222.55L414.529 229.077V223.061C414.529 222.64 414.875 222.277 415.313 222.277C415.749 222.277 416.115 222.64 416.115 223.061V231.556C416.115 231.994 415.749 232.359 415.313 232.359C415.076 232.359 414.856 232.25 414.711 232.066C414.674 232.03 414.655 232.013 414.638 231.977L409.953 225.486V231.556Z",
    fill: "white"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M419.614 231.556V222.932C419.614 222.477 419.98 222.129 420.417 222.129C420.435 222.129 420.435 222.129 420.454 222.129C420.454 222.129 420.454 222.129 420.471 222.129H422.494C424.026 222.129 425.267 223.37 425.267 224.902C425.267 225.522 425.067 226.105 424.721 226.56C425.595 227.107 426.197 228.092 426.197 229.205C426.197 230.936 424.793 232.34 423.061 232.34H420.471C420.454 232.34 420.454 232.323 420.454 232.323C420.417 232.323 420.417 232.34 420.417 232.34C419.98 232.359 419.614 231.994 419.614 231.556ZM421.238 226.086H422.494C423.133 226.086 423.644 225.539 423.644 224.902C423.644 224.263 423.133 223.753 422.494 223.753H421.238V226.086ZM421.238 230.735H423.061C423.9 230.718 424.573 230.062 424.573 229.222C424.573 228.385 423.9 227.727 423.061 227.71H421.238V230.735Z",
    fill: "white"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M436.389 223.387C437.299 224.355 437.865 225.648 437.865 227.09C437.865 228.53 437.299 229.842 436.389 230.791C435.532 231.739 434.237 232.359 432.887 232.359C431.483 232.359 430.188 231.739 429.314 230.791C428.402 229.842 427.874 228.53 427.874 227.09C427.874 225.648 428.421 224.355 429.314 223.387C430.207 222.422 431.483 221.819 432.887 221.819C434.237 221.819 435.513 222.422 436.389 223.387ZM436.188 227.09C436.188 226.086 435.786 225.176 435.186 224.537C434.564 223.881 433.744 223.497 432.87 223.497C431.94 223.497 431.12 223.881 430.498 224.537C429.879 225.176 429.496 226.105 429.496 227.09C429.496 228.092 429.879 229.004 430.498 229.641C431.12 230.299 431.94 230.699 432.87 230.699C433.744 230.699 434.564 230.299 435.186 229.641C435.805 229.004 436.188 228.092 436.188 227.09Z",
    fill: "white"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M447.347 223.516L444.576 227.289L447.347 231.081C447.601 231.428 447.529 231.938 447.165 232.195C447.018 232.304 446.855 232.357 446.691 232.357C446.435 232.357 446.198 232.231 446.035 232.03L443.574 228.656L441.11 232.03C440.948 232.231 440.711 232.357 440.474 232.357C440.29 232.357 440.145 232.304 439.999 232.195C439.634 231.938 439.561 231.428 439.818 231.081L442.589 227.289L439.818 223.516C439.561 223.15 439.634 222.657 439.999 222.403C440.345 222.129 440.856 222.202 441.11 222.584L443.574 225.941L446.035 222.584C446.309 222.202 446.8 222.129 447.165 222.403C447.529 222.64 447.584 223.15 447.347 223.516Z",
    fill: "white"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M478.18 273.51H325.332V283.081H478.18V273.51Z",
    fill: "white"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M478.272 283.192H325.224V273.42H478.272V283.192Z",
    fill: "#EDEDED"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M478.272 273.42H468.499V283.192H478.272V273.42Z",
    fill: "#DFFF02"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M476.43 280.984L475.537 281.659L473.896 279.488L473.295 278.704C473.422 278.65 473.531 278.595 473.642 278.503C473.842 278.341 474.005 278.14 474.097 277.92L474.735 278.759L476.43 280.984Z",
    fill: "white"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M474.682 275.898C473.862 274.841 472.349 274.64 471.291 275.46C470.234 276.281 470.033 277.793 470.853 278.851C471.582 279.8 472.877 280.054 473.898 279.507C474.007 279.453 474.135 279.381 474.227 279.289C474.428 279.144 474.59 278.96 474.718 278.761C475.338 277.922 475.338 276.755 474.682 275.898ZM473.643 278.505C473.533 278.597 473.424 278.65 473.295 278.706C472.712 278.943 472.02 278.778 471.618 278.251C471.127 277.612 471.255 276.719 471.892 276.225C472.53 275.734 473.424 275.862 473.917 276.499C474.244 276.919 474.299 277.466 474.099 277.941C474.007 278.14 473.862 278.34 473.643 278.505Z",
    fill: "white"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M327.829 275.407H327.319V281.222H327.829V275.407Z",
    fill: "#D9D9D9"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M538.75 268.623C538.184 268.971 537.564 269.245 536.872 269.407C535.102 269.845 533.333 269.499 531.913 268.623C530.507 267.766 529.432 266.363 529.013 264.632C528.156 261.13 530.289 257.611 533.789 256.772C537.271 255.915 540.809 258.066 541.649 261.549C542.341 264.358 541.083 267.183 538.75 268.623Z",
    fill: "#DFFF02"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M537.309 262.352C537.309 263.446 536.416 264.339 535.322 264.339C534.228 264.339 533.335 263.446 533.335 262.352C533.335 261.258 534.228 260.365 535.322 260.365C536.435 260.365 537.309 261.258 537.309 262.352Z",
    fill: "white"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M538.75 267.805V268.625C538.185 268.971 537.564 269.245 536.871 269.409C535.102 269.845 533.335 269.499 531.912 268.625V267.805C531.912 265.927 533.444 264.376 535.34 264.376C537.237 264.376 538.75 265.927 538.75 267.805Z",
    fill: "white"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M550.127 298.528H300.755V318.292H550.127V298.528Z",
    fill: "#EDEDED"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M322.178 305.438H316.234V311.382H322.178V305.438Z",
    fill: "white"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M347.394 311.382H341.469L343.875 308.41L341.469 305.438H347.394L349.819 308.41L347.394 311.382Z",
    fill: "white"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M332.132 305.438L333.1 307.408L335.269 307.718L333.701 309.231L334.066 311.382L332.132 310.38L330.201 311.382L330.583 309.231L329.015 307.718L331.167 307.408L332.132 305.438Z",
    fill: "#DFFF02"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M401.402 307.205H354.086V309.63H401.402V307.205Z",
    fill: "#4A4A4A"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M524.674 307.205H481.718V309.63H524.674V307.205Z",
    fill: "#4A4A4A"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M463.681 307.205H415.839V309.63H463.681V307.205Z",
    fill: "#212121"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M322.178 325.221H316.234V331.165H322.178V325.221Z",
    fill: "white",
    stroke: "#EDEDED",
    strokeWidth: 0.956233,
    strokeMiterlimit: 10
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M347.394 331.165H341.469L343.875 328.193L341.469 325.221H347.394L349.819 328.193L347.394 331.165Z",
    fill: "white",
    stroke: "#EDEDED",
    strokeWidth: 0.956233,
    strokeMiterlimit: 10
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M332.132 325.221L333.1 327.171L335.269 327.481L333.701 329.013L334.066 331.165L332.132 330.143L330.201 331.165L330.583 329.013L329.015 327.481L331.167 327.171L332.132 325.221Z",
    fill: "#DFFF02"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M401.402 326.973H354.086V329.378H401.402V326.973Z",
    fill: "#4A4A4A"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M524.674 326.973H481.718V329.378H524.674V326.973Z",
    fill: "#4A4A4A"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M463.681 326.973H415.839V329.378H463.681V326.973Z",
    fill: "#212121"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M550.127 338.076H300.755V357.842H550.127V338.076Z",
    fill: "#EDEDED"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M322.178 344.988H316.234V350.932H322.178V344.988Z",
    fill: "white"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M347.394 350.932H341.469L343.875 347.96L341.469 344.988H347.394L349.819 347.96L347.394 350.932Z",
    fill: "white"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M332.132 344.988L333.1 346.939L335.269 347.266L333.701 348.78L334.066 350.932L332.132 349.911L330.201 350.932L330.583 348.78L329.015 347.266L331.167 346.939L332.132 344.988Z",
    fill: "white"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M401.402 346.753H354.086V349.161H401.402V346.753Z",
    fill: "#D9D9D9"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M524.674 346.753H481.718V349.161H524.674V346.753Z",
    fill: "#D9D9D9"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M463.681 346.753H415.839V349.161H463.681V346.753Z",
    fill: "#D9D9D9"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M322.178 364.751H316.234V370.695H322.178V364.751Z",
    fill: "white",
    stroke: "#EDEDED",
    strokeWidth: 0.956233,
    strokeMiterlimit: 10
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M347.394 370.695H341.469L343.875 367.723L341.469 364.751H347.394L349.819 367.723L347.394 370.695Z",
    fill: "white",
    stroke: "#EDEDED",
    strokeWidth: 0.956233,
    strokeMiterlimit: 10
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M332.132 364.751L333.1 366.719L335.269 367.029L333.701 368.544L334.066 370.695L332.132 369.691L330.201 370.695L330.583 368.544L329.015 367.029L331.167 366.719L332.132 364.751Z",
    fill: "#DFFF02"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M401.402 366.517H354.086V368.924H401.402V366.517Z",
    fill: "#D9D9D9"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M524.674 366.517H481.718V368.924H524.674V366.517Z",
    fill: "#D9D9D9"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M463.681 366.517H415.839V368.924H463.681V366.517Z",
    fill: "#D9D9D9"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M550.127 377.622H300.755V397.388H550.127V377.622Z",
    fill: "#EDEDED"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M322.178 384.532H316.234V390.476H322.178V384.532Z",
    fill: "white"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M347.394 390.476H341.469L343.875 387.504L341.469 384.532H347.394L349.819 387.504L347.394 390.476Z",
    fill: "white"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M332.132 384.532L333.1 386.485L335.269 386.794L333.701 388.324L334.066 390.476L332.132 389.457L330.201 390.476L330.583 388.324L329.015 386.794L331.167 386.485L332.132 384.532Z",
    fill: "#DFFF02"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M401.402 386.284H354.086V388.692H401.402V386.284Z",
    fill: "#D9D9D9"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M524.674 386.284H481.718V388.692H524.674V386.284Z",
    fill: "#D9D9D9"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M463.681 386.284H415.839V388.692H463.681V386.284Z",
    fill: "#D9D9D9"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M322.178 404.296H316.234V410.24H322.178V404.296Z",
    fill: "white",
    stroke: "#EDEDED",
    strokeWidth: 0.956233,
    strokeMiterlimit: 10
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M347.394 410.24H341.469L343.875 407.268L341.469 404.296H347.394L349.819 407.268L347.394 410.24Z",
    fill: "white",
    stroke: "#EDEDED",
    strokeWidth: 0.956233,
    strokeMiterlimit: 10
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M332.132 404.296L333.1 406.248L335.269 406.575L333.701 408.088L334.066 410.24L332.132 409.22L330.201 410.24L330.583 408.088L329.015 406.575L331.167 406.248L332.132 404.296Z",
    fill: "white",
    stroke: "#EDEDED",
    strokeWidth: 0.956233,
    strokeMiterlimit: 10
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M401.402 406.062H354.086V408.47H401.402V406.062Z",
    fill: "#D9D9D9"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M524.674 406.062H481.718V408.47H524.674V406.062Z",
    fill: "#D9D9D9"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M463.681 406.062H415.839V408.47H463.681V406.062Z",
    fill: "#D9D9D9"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M550.127 417.153H300.755V436.918H550.127V417.153Z",
    fill: "#EDEDED"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M322.178 424.063H316.234V430.007H322.178V424.063Z",
    fill: "white"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M347.394 430.007H341.469L343.875 427.035L341.469 424.063H347.394L349.819 427.035L347.394 430.007Z",
    fill: "white"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M332.132 424.063L333.1 426.033L335.269 426.342L333.701 427.855L334.066 430.007L332.132 429.005L330.201 430.007L330.583 427.855L329.015 426.342L331.167 426.033L332.132 424.063Z",
    fill: "#DFFF02"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M401.402 425.83H354.086V428.255H401.402V425.83Z",
    fill: "#D9D9D9"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M524.674 425.83H481.718V428.255H524.674V425.83Z",
    fill: "#D9D9D9"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M463.681 425.83H415.839V428.255H463.681V425.83Z",
    fill: "#D9D9D9"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M322.178 443.845H316.234V449.789H322.178V443.845Z",
    fill: "white",
    stroke: "#EDEDED",
    strokeWidth: 0.956233,
    strokeMiterlimit: 10
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M347.394 449.789H341.469L343.875 446.817L341.469 443.845H347.394L349.819 446.817L347.394 449.789Z",
    fill: "white",
    stroke: "#EDEDED",
    strokeWidth: 0.956233,
    strokeMiterlimit: 10
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M332.132 443.845L333.1 445.796L335.269 446.106L333.701 447.638L334.066 449.789L332.132 448.768L330.201 449.789L330.583 447.638L329.015 446.106L331.167 445.796L332.132 443.845Z",
    fill: "white",
    stroke: "#EDEDED",
    strokeWidth: 0.956233,
    strokeMiterlimit: 10
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M401.402 445.597H354.086V448.022H401.402V445.597Z",
    fill: "#D9D9D9"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M524.674 445.597H481.718V448.022H524.674V445.597Z",
    fill: "#D9D9D9"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M463.681 445.597H415.839V448.022H463.681V445.597Z",
    fill: "#D9D9D9"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M550.127 456.699H300.755V476.463H550.127V456.699Z",
    fill: "#EDEDED"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M322.178 463.609H316.234V469.553H322.178V463.609Z",
    fill: "white"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M347.394 469.553H341.469L343.875 466.581L341.469 463.609H347.394L349.819 466.581L347.394 469.553Z",
    fill: "white"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M332.132 463.609L333.1 465.56L335.269 465.889L333.701 467.401L334.066 469.553L332.132 468.532L330.201 469.553L330.583 467.401L329.015 465.889L331.167 465.56L332.132 463.609Z",
    fill: "white"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M401.402 465.376H354.086V467.801H401.402V465.376Z",
    fill: "#D9D9D9"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M524.674 465.376H481.718V467.801H524.674V465.376Z",
    fill: "#D9D9D9"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M463.681 465.376H415.839V467.801H463.681V465.376Z",
    fill: "#D9D9D9"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M322.178 483.376H316.234V489.32H322.178V483.376Z",
    fill: "white",
    stroke: "#EDEDED",
    strokeWidth: 0.956233,
    strokeMiterlimit: 10
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M347.394 489.32H341.469L343.875 486.348L341.469 483.376H347.394L349.819 486.348L347.394 489.32Z",
    fill: "white",
    stroke: "#EDEDED",
    strokeWidth: 0.956233,
    strokeMiterlimit: 10
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M332.132 483.376L333.1 485.346L335.269 485.656L333.701 487.168L334.066 489.32L332.132 488.318L330.201 489.32L330.583 487.168L329.015 485.656L331.167 485.346L332.132 483.376Z",
    fill: "white",
    stroke: "#EDEDED",
    strokeWidth: 0.956233,
    strokeMiterlimit: 10
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M401.402 485.143H354.086V487.549H401.402V485.143Z",
    fill: "#D9D9D9"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M524.674 485.143H481.718V487.549H524.674V485.143Z",
    fill: "#D9D9D9"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M463.681 485.143H415.839V487.549H463.681V485.143Z",
    fill: "#D9D9D9"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M550.127 496.247H300.755V516.012H550.127V496.247Z",
    fill: "#EDEDED"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M322.178 503.158H316.234V509.102H322.178V503.158Z",
    fill: "white"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M347.394 509.102H341.469L343.875 506.13L341.469 503.158H347.394L349.819 506.13L347.394 509.102Z",
    fill: "white"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M332.132 503.158L333.1 505.109L335.269 505.419L333.701 506.951L334.066 509.102L332.132 508.081L330.201 509.102L330.583 506.951L329.015 505.419L331.167 505.109L332.132 503.158Z",
    fill: "white",
    stroke: "#EDEDED",
    strokeWidth: 0.956233,
    strokeMiterlimit: 10
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M401.402 504.91H354.086V507.316H401.402V504.91Z",
    fill: "#D9D9D9"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M524.674 504.91H481.718V507.316H524.674V504.91Z",
    fill: "#D9D9D9"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M463.681 504.91H415.839V507.316H463.681V504.91Z",
    fill: "#D9D9D9"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M322.178 522.922H316.234V528.866H322.178V522.922Z",
    fill: "white",
    stroke: "#EDEDED",
    strokeWidth: 0.956233,
    strokeMiterlimit: 10
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M347.394 528.866H341.469L343.875 525.894L341.469 522.922H347.394L349.819 525.894L347.394 528.866Z",
    fill: "white",
    stroke: "#EDEDED",
    strokeWidth: 0.956233,
    strokeMiterlimit: 10
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M332.132 522.922L333.1 524.873L335.269 525.2L333.701 526.714L334.066 528.866L332.132 527.845L330.201 528.866L330.583 526.714L329.015 525.2L331.167 524.873L332.132 522.922Z",
    fill: "white",
    stroke: "#EDEDED",
    strokeWidth: 0.956233,
    strokeMiterlimit: 10
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M401.402 524.689H354.086V527.095H401.402V524.689Z",
    fill: "#D9D9D9"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M524.674 524.689H481.718V527.095H524.674V524.689Z",
    fill: "#D9D9D9"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M463.681 524.689H415.839V527.095H463.681V524.689Z",
    fill: "#D9D9D9"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M550.127 535.774H300.755V555.539H550.127V535.774Z",
    fill: "#EDEDED"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M322.178 542.685H316.234V548.629H322.178V542.685Z",
    fill: "white"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M347.394 548.629H341.469L343.875 545.657L341.469 542.685H347.394L349.819 545.657L347.394 548.629Z",
    fill: "white"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M332.132 542.685L333.1 544.653L335.269 544.963L333.701 546.478L334.066 548.629L332.132 547.625L330.201 548.629L330.583 546.478L329.015 544.963L331.167 544.653L332.132 542.685Z",
    fill: "white",
    stroke: "#EDEDED",
    strokeWidth: 0.956233,
    strokeMiterlimit: 10
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M401.402 544.453H354.086V546.858H401.402V544.453Z",
    fill: "#D9D9D9"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M524.674 544.453H481.718V546.858H524.674V544.453Z",
    fill: "#D9D9D9"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M463.681 544.453H415.839V546.858H463.681V544.453Z",
    fill: "#D9D9D9"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M322.178 562.47H316.234V568.414H322.178V562.47Z",
    fill: "white",
    stroke: "#EDEDED",
    strokeWidth: 0.956233,
    strokeMiterlimit: 10
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M347.394 568.414H341.469L343.875 565.442L341.469 562.47H347.394L349.819 565.442L347.394 568.414Z",
    fill: "white",
    stroke: "#EDEDED",
    strokeWidth: 0.956233,
    strokeMiterlimit: 10
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M332.132 562.47L333.1 564.422L335.269 564.732L333.701 566.262L334.066 568.414L332.132 567.394L330.201 568.414L330.583 566.262L329.015 564.732L331.167 564.422L332.132 562.47Z",
    fill: "white",
    stroke: "#EDEDED",
    strokeWidth: 0.956233,
    strokeMiterlimit: 10
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M401.402 564.222H354.086V566.629H401.402V564.222Z",
    fill: "#D9D9D9"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M524.674 564.222H481.718V566.629H524.674V564.222Z",
    fill: "#D9D9D9"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M463.681 564.222H415.839V566.629H463.681V564.222Z",
    fill: "#D9D9D9"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M550.127 575.324H300.755V595.089H550.127V575.324Z",
    fill: "#EDEDED"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M322.178 582.234H316.234V588.177H322.178V582.234Z",
    fill: "white"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M347.394 588.177H341.469L343.875 585.205L341.469 582.234H347.394L349.819 585.205L347.394 588.177Z",
    fill: "white"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M332.132 582.234L333.1 584.186L335.269 584.513L333.701 586.026L334.066 588.177L332.132 587.158L330.201 588.177L330.583 586.026L329.015 584.513L331.167 584.186L332.132 582.234Z",
    fill: "#DFFF02"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M401.402 584H354.086V586.408H401.402V584Z",
    fill: "#D9D9D9"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M524.674 584H481.718V586.408H524.674V584Z",
    fill: "#D9D9D9"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M463.681 584H415.839V586.408H463.681V584Z",
    fill: "#D9D9D9"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M322.178 601.997H316.234V607.941H322.178V601.997Z",
    fill: "white",
    stroke: "#EDEDED",
    strokeWidth: 0.956233,
    strokeMiterlimit: 10
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M347.394 607.941H341.469L343.875 604.969L341.469 601.997H347.394L349.819 604.969L347.394 607.941Z",
    fill: "white",
    stroke: "#EDEDED",
    strokeWidth: 0.956233,
    strokeMiterlimit: 10
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M332.132 601.997L333.1 603.967L335.269 604.277L333.701 605.789L334.066 607.941L332.132 606.939L330.201 607.941L330.583 605.789L329.015 604.277L331.167 603.967L332.132 601.997Z",
    fill: "white",
    stroke: "#EDEDED",
    strokeWidth: 0.956233,
    strokeMiterlimit: 10
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M401.402 603.764H354.086V606.172H401.402V603.764Z",
    fill: "#D9D9D9"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M524.674 603.764H481.718V606.172H524.674V603.764Z",
    fill: "#D9D9D9"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M463.681 603.764H415.839V606.172H463.681V603.764Z",
    fill: "#D9D9D9"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M550.127 614.87H300.755V634.633H550.127V614.87Z",
    fill: "#EDEDED"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M322.178 621.779H316.234V627.723H322.178V621.779Z",
    fill: "white"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M347.394 627.723H341.469L343.875 624.751L341.469 621.779H347.394L349.819 624.751L347.394 627.723Z",
    fill: "white"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M332.132 621.779L333.1 623.73L335.269 624.04L333.701 625.572L334.066 627.723L332.132 626.702L330.201 627.723L330.583 625.572L329.015 624.04L331.167 623.73L332.132 621.779Z",
    fill: "#DFFF02"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M401.402 623.531H354.086V625.939H401.402V623.531Z",
    fill: "#D9D9D9"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M524.674 623.531H481.718V625.939H524.674V623.531Z",
    fill: "#D9D9D9"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M463.681 623.531H415.839V625.939H463.681V623.531Z",
    fill: "#D9D9D9"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M322.178 641.546H316.234V647.49H322.178V641.546Z",
    fill: "white",
    stroke: "#EDEDED",
    strokeWidth: 0.956233,
    strokeMiterlimit: 10
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M347.394 647.49H341.469L343.875 644.518L341.469 641.546H347.394L349.819 644.518L347.394 647.49Z",
    fill: "white",
    stroke: "#EDEDED",
    strokeWidth: 0.956233,
    strokeMiterlimit: 10
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M332.132 641.546L333.1 643.497L335.269 643.826L333.701 645.339L334.066 647.49L332.132 646.469L330.201 647.49L330.583 645.339L329.015 643.826L331.167 643.497L332.132 641.546Z",
    fill: "white",
    stroke: "#EDEDED",
    strokeWidth: 0.956233,
    strokeMiterlimit: 10
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M401.402 643.314H354.086V645.739H401.402V643.314Z",
    fill: "#D9D9D9"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M524.674 643.314H481.718V645.739H524.674V643.314Z",
    fill: "#D9D9D9"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M463.681 643.314H415.839V645.739H463.681V643.314Z",
    fill: "#D9D9D9"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M550.092 654.4C549.727 663.28 544.659 670.828 537.529 674.164H313.373C306.207 670.809 301.156 663.261 300.791 654.4H550.092Z",
    fill: "#EDEDED"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M322.178 661.31H316.234V667.254H322.178V661.31Z",
    fill: "white"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M347.394 667.254H341.469L343.875 664.282L341.469 661.31H347.394L349.819 664.282L347.394 667.254Z",
    fill: "white"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M332.132 661.31L333.1 663.28L335.269 663.59L333.701 665.102L334.066 667.254L332.132 666.252L330.201 667.254L330.583 665.102L329.015 663.59L331.167 663.28L332.132 661.31Z",
    fill: "#DFFF02"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M401.402 663.077H354.086V665.483H401.402V663.077Z",
    fill: "#D9D9D9"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M524.674 663.077H481.718V665.483H524.674V663.077Z",
    fill: "#D9D9D9"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M463.681 663.077H415.839V665.483H463.681V663.077Z",
    fill: "#D9D9D9"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M550.691 208.509V652.775C550.691 665.338 541.284 675.493 529.686 675.493H322.341C310.709 675.493 301.319 665.338 301.319 652.775V208.509C301.319 182.928 310.726 181.688 322.341 181.688H363.876C366.283 181.688 368.27 184.423 368.27 187.832V189.291C368.27 197.259 372.627 197.277 377.97 197.277H474.022C479.419 197.277 483.759 197.241 483.759 189.291V187.832C483.759 184.441 485.709 181.688 488.151 181.688H529.669C541.284 181.688 550.691 185.079 550.691 208.509Z",
    fill: "white"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M561.558 190.731C561.558 177.822 551.093 167.374 538.203 167.374C538.203 167.374 538.203 167.374 538.183 167.374H309.961C297.052 167.374 286.587 177.822 286.587 190.731C286.587 190.731 286.587 190.731 286.587 190.749V670.587C286.587 683.496 297.052 693.944 309.942 693.944C309.942 693.944 309.942 693.944 309.961 693.944H538.183C551.093 693.944 561.558 683.496 561.558 670.587C561.558 670.587 561.558 670.587 561.558 670.57V190.731ZM553.663 652.354C553.537 661.69 545.86 669.166 536.525 669.038H311.602C302.267 669.147 294.608 661.69 294.482 652.354V195.781C294.608 186.446 302.267 178.971 311.602 179.098H392.484C397.279 179.098 401.673 181.724 403.951 185.936C410.115 197.039 424.118 201.051 435.222 194.888C438.978 192.791 442.078 189.692 444.174 185.936L444.211 185.863C446.49 181.687 450.866 179.098 455.624 179.098H536.579C545.914 178.989 553.59 186.446 553.718 195.781L553.663 652.354Z",
    fill: "#4A4A4A"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_91_1608)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M439.204 299C453.451 299 465 310.549 465 324.796V352.204C465 359.212 462.203 365.565 457.668 370.214L460.163 387.674L437.839 378H411.796C397.549 378 386 366.451 386 352.204V324.796C386 310.549 397.549 299 411.796 299H439.204Z",
    fill: "#22420D"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 405.347,
    cy: 339.306,
    r: 4.83673,
    fill: "#97EC5F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 424.694,
    cy: 339.306,
    r: 4.83673,
    fill: "#97EC5F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 444.041,
    cy: 339.306,
    r: 4.83673,
    fill: "#97EC5F"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_dd_91_1608)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 385,
    y: 419.673,
    width: 81.1077,
    height: 81.1077,
    rx: 29.4937,
    fill: "#22420D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.028 447.719L436.481 443.176C436.161 442.854 435.779 442.598 435.359 442.424C434.94 442.25 434.489 442.16 434.035 442.16C433.108 442.16 432.237 442.523 431.584 443.176L426.691 448.069C426.369 448.39 426.113 448.771 425.939 449.191C425.765 449.611 425.675 450.061 425.675 450.516C425.675 451.442 426.038 452.313 426.691 452.966L430.269 456.544C429.432 458.39 428.267 460.07 426.832 461.501C425.401 462.94 423.721 464.109 421.875 464.951L418.297 461.373C417.976 461.051 417.595 460.795 417.175 460.621C416.755 460.447 416.305 460.357 415.851 460.357C414.924 460.357 414.053 460.72 413.4 461.373L408.503 466.262C408.18 466.583 407.924 466.965 407.75 467.386C407.575 467.806 407.486 468.257 407.486 468.713C407.486 469.639 407.849 470.51 408.503 471.163L413.041 475.702C414.083 476.748 415.522 477.341 416.999 477.341C417.311 477.341 417.61 477.316 417.904 477.265C423.66 476.317 429.368 473.255 433.975 468.653C438.578 464.055 441.635 458.35 442.595 452.578C442.886 450.814 442.301 449 441.028 447.719Z",
    fill: "#97EC5F"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_dd_91_1608)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 385,
    y: 532.781,
    width: 81,
    height: 81,
    rx: 29.4545,
    fill: "#22420D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M425.964 552.338C414.34 552.338 404.557 561.366 404.557 573.406C404.557 584.13 412.471 593.272 423.309 593.272C425.767 593.272 427.494 592.952 428.542 592.244C429.433 591.671 429.89 590.866 430.013 589.993C430.134 589.134 429.932 588.236 429.559 587.441C429.307 586.905 428.733 586.664 428.205 586.739C426.721 586.946 425.278 587.121 423.799 587.121C416.01 587.121 410.708 580.302 410.708 573.405C410.708 565.545 417.649 558.448 425.963 558.448C430.147 558.448 433.489 559.776 435.781 561.91C438.071 564.041 439.34 567 439.34 570.321C439.34 572.676 438.626 574.737 437.521 575.961C436.971 576.567 436.335 576.959 435.648 577.098C435.043 577.221 434.364 577.157 433.625 576.83L434.825 569.027C435.133 567.396 434.396 565.803 433.092 564.856L433.088 564.854C431.004 563.371 428.538 562.756 426.045 562.756C419.782 562.756 415.257 567.511 415.257 573.705C415.257 576.27 416.144 578.498 417.702 580.086C419.26 581.675 421.463 582.597 424.044 582.597C425.768 582.597 427.582 582.266 429.141 581.389C430.763 582.371 432.683 582.811 434.54 582.811C438.185 582.811 440.943 581.39 442.779 579.091C444.605 576.804 445.491 573.686 445.491 570.322C445.491 559.399 435.977 552.338 425.964 552.338ZM423.951 570.431C424.528 569.7 425.206 569.362 426.004 569.362C426.505 569.362 427.007 569.417 427.402 569.591L426.836 575.765C426.385 576.055 425.854 576.205 425.228 576.205C424.457 576.205 423.941 575.925 423.605 575.502C423.259 575.066 423.068 574.426 423.068 573.662C423.068 572.175 423.385 571.124 423.946 570.437L423.951 570.431Z",
    fill: "#97EC5F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_91_1608",
    x: 379.928,
    y: 297.786,
    width: 91.1446,
    height: 100.818,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.42893
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.21446
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_91_1608"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.21446,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect2_dropShadow_91_1608"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.85785
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.42893
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_91_1608",
    result: "effect2_dropShadow_91_1608"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_91_1608",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_dd_91_1608",
    x: 378.928,
    y: 418.459,
    width: 93.2523,
    height: 93.2523,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.42893
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.21446
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_91_1608"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.21446,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect2_dropShadow_91_1608"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.85785
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.42893
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_91_1608",
    result: "effect2_dropShadow_91_1608"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_91_1608",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_dd_91_1608",
    x: 378.936,
    y: 531.568,
    width: 93.1285,
    height: 93.1285,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.4257
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.21285
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_91_1608"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.21285,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect2_dropShadow_91_1608"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.85141
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.4257
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_91_1608",
    result: "effect2_dropShadow_91_1608"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_91_1608",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.d995f9b884a0ec5f101cc0f485472efc.svg";
export { ForwardRef as ReactComponent };